import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PricingOptions } from '@tsapiclient/zenauto.vehiclequotation.ts.client/interfaces/pricingoptions';
import type { RootState } from '../store';

export const initialState: PricingOptions | object = {};

export const pricingOptionsSlice = createSlice({
  name: 'pricingOptions',
  initialState: initialState,
  reducers: {
    setPricingOptions: (
      state,
      action: PayloadAction<PricingOptions | object>
    ) => {
      return { ...state, ...action.payload };
    },
  },
});

export const { setPricingOptions } = pricingOptionsSlice.actions;

export const pricingOptions = (state: RootState) => state.pricingOptions;

export default pricingOptionsSlice.reducer;
